import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Btn, InputField } from './UIComponents';

export function BillingModal({ onClose }) {
  const { B } = useTheme();

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 500,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
    '@media (maxWidth: 768px)': {
      gridTemplateColumns: '1fr',
    },
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 16,
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>New Billing Claim</div>
        <InputField label="Resident" select options={['Select…']} />
        <InputField label="Payer" select options={['Select…', 'Medicaid', 'Medicare', 'Medicaid/Medicare', 'Private Pay']} />
        <InputField label="Service Type" select options={['Select…', '24hr Residential Care', 'Skilled Nursing', 'PT Services', 'Memory Care + BSP', 'Diabetic Foot Care']} />
        <div style={gridStyle}>
          <InputField label="Period Start" type="date" />
          <InputField label="Period End" type="date" />
          <InputField label="Amount ($)" placeholder="0.00" />
          <InputField label="Status" select options={['Submitted', 'Draft']} />
        </div>
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>Cancel</Btn>
          <Btn color={B.navy}>Submit Claim</Btn>
        </div>
      </div>
    </div>
  );
}

export function PaymentModal({ onClose, claim, onConfirm }) {
  const { B } = useTheme();
  const [amount, setAmount] = React.useState(claim?.amount || '');
  const [paymentDate, setPaymentDate] = React.useState(new Date().toISOString().split('T')[0]);
  const [paymentMethod, setPaymentMethod] = React.useState('');

  const handleConfirm = () => {
    if (onConfirm) onConfirm({ amount, payment_date: paymentDate, payment_method: paymentMethod });
    if (onClose) onClose();
  };

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 420,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 16,
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>Record Payment</div>
        {claim && <div style={{ fontSize: 12, color: B.muted, marginBottom: 16 }}>Claim: {claim.invoice_number || `INV-${claim.id}`}</div>}
        <InputField label="Amount Received ($)" placeholder="0.00" value={amount} onChange={(e) => setAmount(e.target.value)} />
        <InputField label="Payment Date" type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
        <InputField label="Payment Method" select options={['Select…', 'EFT', 'Check', 'ACH', 'Wire', 'Credit Card']} value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} />
        <InputField label="Reference Number" placeholder="Ref #" />
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>Cancel</Btn>
          <Btn color={B.green} onClick={handleConfirm}>Record Payment</Btn>
        </div>
      </div>
    </div>
  );
}

export default BillingModal;